<template>
  <div class="chat-container w-100 position-relative bg-white">
    <div id="member"></div>
    <div class="position-relative z-index-1028">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div :class="{'bg-white box-shadow-nav':scrollPosition > 30}">
                  <div class="container px-4 w-100 py-1">
                    <div class="row no-gutters py-2 m-0 w-100">
                      <div class="col-1" v-if="disabled_register">
                        <div class="cursor-pointer">
                          <img @click="changeDisplay(false)" src="../../../../assets/img/icon/back-arrow.png" class="mt-1" width="15">
                        </div>
                      </div>
                      <div class="col-7">
                        <div class="">
                          <transition name="fade">
                            <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1">{{$t('hotel.concierge.member')}}</p>
                          </transition>
                        </div>
                      </div>
                      <!-- <div class="col-4 text-right">
                        <div class="mt-1">
                          <img src="../../../../assets/img/hotel/avatar-img.jpg" width="30" height="30" class="rounded-100 object-fit d-inline-block">
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 65px"></div>
    <div v-if="is_load" class="mx-auto mt-5">
      <loader></loader>
    </div>
    <template v-else>
      <ErrorMessage v-if="error != ''" :message="error" />
      <template v-else>
        <div class="container px-4 w-100 pt-2 pb-4">
          <ErrorMessage v-if="reject_message!=''" :message="$t('warning-message.member-request-rejected')+reject_message" />
          <!-- Banner 1 -->
          <template v-if="banner == '1'"> 
            <div class="p-4 rounded-6 position-relative h-slide-reward" style="background: rgb(121,163,58);background: linear-gradient(153deg, rgba(121,163,58,1) 48%, rgba(182,222,123,1) 100%);">
              <div class="position-relative w-100" style="z-index: 9">
                <p class="mb-0 body-1-1 text-18 text-white" @click="banner = '2'" style="text-shadow: 1px 1px 1px #887c7c">{{$t('hotel.concierge.member-banner.title')}}</p>
                <p class="mb-2 body-3-3-1 text-white w-75">{{$t('hotel.concierge.member-banner.subtitle')}}</p>
                <button type="button" class="button-primary bg-white text-green my-1 px-4 py-2 text-12" @click="onScroll('all member')">{{$t('hotel.concierge.member-banner.action')}}</button>
              </div>
              <img src="../../../../assets/img/icon/gift.png" width="180" class="position-absolute text-right" style="right: 17px;top: 15px;z-index: 8">
            </div>
          </template>
          <!-- Banner 2 -->
          <template v-else>
            <div class="p-4 rounded-6 position-relative h-slide-reward" style="background: linear-gradient(153deg, rgb(129 175 204) 48%, rgb(43 148 152) 100%)">
              <div class="position-relative w-100" style="z-index: 9">
                <p class="mb-0 body-1-1 text-18 text-white" @click="banner = '1'" style="text-shadow: 1px 1px 1px #887c7c">{{$t('hotel.concierge.member-banner.title')}}</p>
                <p class="mb-2 body-3-3-1 text-white w-75">{{$t('hotel.concierge.member-banner.subtitle')}}</p>
                <button type="button" class="button-primary my-1 px-4 py-2 text-12" @click="onScroll('all member')">{{$t('hotel.concierge.member-banner.action')}}</button>
              </div>
              <img src="../../../../assets/img/icon/gift.png" width="180" class="position-absolute text-right" style="right: 17px;top: 15px;z-index: 8">
            </div>
          </template>
        </div>
        <div class="container px-4 pt-1 pb-5">
          <p class="mb-0 body-1-1 text-18">{{$t('hotel.concierge.member-card-type')}}</p>
          <p class="mb-3 body-3-3-1">{{$t('hotel.concierge.member-card-type-desc')}}</p>
           <!-- Member Card Slide-->
          
          <flickity ref="flickity"
            :options="flickityOptionsCard" class="slider-card">
            <div class="carousel-cell w-100 mr-3 mb-3 bg-card-height slider-card" v-for="card_data in card_list">
              <div class="position-absolute w-100" style="z-index: 9">
                <MemberCard @detail="goToDetail" :data="parsingDataCard(card_data)" :guest_name="guest_name"></MemberCard>
              </div>
              <div class="w-80 mr-3 mb-3 border bg-card bg-card-height position-absolute box-shadow-main card-left" style="top:8px;opacity: 55%;z-index: 8" :style="{backgroundColor: card_data.card_color_accent}">
              </div>
            </div>  
          </flickity>
        </div>
        <!-- Keuntungan -->
        <!-- <div id="daftar-member" class="position-relative" style="top: -70px"></div> -->
        <div id="all member" class="position-relative" style="top: -70px"></div>
        <div class="container pt-1 px-4 mb-4">
          <p class="mb-0 body-1-1 text-18">{{$t('hotel.concierge.benefit-being-member')}}</p>
          <p class="mb-4 body-3-3-1">{{$t('hotel.concierge.benefit-being-member-desc')}}</p>
          <template v-for="(data_card, index) in card_list">
            <MemberCardItem 
              :data_card="data_card" 
              :disabled_btn="disabled_btn" 
              :disabled_register="disabled_register"
              @detail="detailCard"
              @push="pushReqMember"
              @done="changeDisplay"></MemberCardItem>
          </template>
        </div>
      </template>
    </template>

    <BottomNavbar></BottomNavbar>

    <!-- Detail -->
    <MemberCardDetail 
      :selected_card="selected_card" 
      :disabled_btn="disabled_btn" 
      :guest_name="guest_name"
      :disabled_register="disabled_register" 
      @close="detailCard"
      @push="pushReqMember"
      @done="changeDisplay"></MemberCardDetail>

    <popupWarningAddProduct v-if="is_not_user != ''" @close="is_not_user = ''" :body="is_not_user" :title="$t('general.authentication-required')"></popupWarningAddProduct>

  </div>
</template>
<script>
  import BottomNavbar from '@/components/hotel/BottomNavbar';
  import MemberCard from '@/components/hotel/concierge/member/MemberCard'
  import MemberCardItem from '@/components/hotel/concierge/member/MemberCardItem'
  import MemberCardDetail from '@/components/hotel/concierge/member/MemberCardDetail'
  import MemberCardSlide from '@/components/hotel/concierge/member/MemberCardSlide'
  import Flickity from 'vue-flickity';
  import {mapGetters} from "vuex";
  import food3 from '../../../../assets/img/restaurant/food (3).jpg' 
  import voucher1 from '../../../../assets/img/restaurant/promo (3).jpg' 
  import voucher2 from '../../../../assets/img/restaurant/promo (2).jpg' 
  import {get} from '@/services/index.js'

  export default{
    props:['disabled_register','reject_message'],
    components: {
      Flickity,
      BottomNavbar,
      MemberCard,
      MemberCardSlide,
      MemberCardItem,
      MemberCardDetail
    },
    data() {
      return {
        scrollPosition: null,
        popup_not_login: false,
        banner: '1',
        flickityOptionsCard: {
          initialIndex: 0,
          autoPlay: 3000,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: true,
          cellAlign: "left",
          draggable: true,
          wrapAround: true,
        },

        // fix
        is_load: true,
        error: '',
        card_list: [],
        guest_name: '',
        selected_card: {},
        is_not_user: '',
        push_request_member: false,
        disabled_btn: false
      }
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      document.getElementById('member').scrollIntoView({
        behavior: 'smooth'
      });
      this.loadDetailReservation().then(()=>{
        this.loadCardList()
      })
    },
    methods: {
      ...mapGetters(['getMerchant','getConciergeAuth','getConciergeReservation']),
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      onScroll(data){
        document.getElementById(data).scrollIntoView({
          behavior: 'smooth'
        });
      },
      parsingDataCard(data){
        let copied = JSON.parse(JSON.stringify(data))
        delete copied.benefit
        delete copied.return_product
        return copied
      },
      detailCard(data=null){
        this.selected_card = data == null ? {} : data
      },
      pushReqMember(data){
        this.disabled_btn = data
      },
      changeDisplay(reload=true){
        this.$emit("change_display",reload)
      }, 
      goToDetail(data){
        let id_component = data.id
        document.getElementById(id_component).scrollIntoView({
          behavior: 'smooth'
        });
      },
      loadDetailReservation(){
        return new Promise(done=>{
          get("CONCIERGE","reservation-by-booking-number/"+this.getConciergeAuth().booking_number,{
            merchant_id: this.getMerchant().id
          },'concierge_pin').then(response=>{
            this.guest_name = response.data.data.guest_profile.name
            done(true)
          })
        })
      },
      loadCardList(){
        this.is_load = true
        this.error = ''

        get("CONCIERGE","membership/card-list",{
          merchant_id : this.getMerchant().id
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.card_list = res.data
          }else{ 
            this.error = res.message
          }
          this.is_load = false
        })
      }
    }
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/member/CardMemberList.vue